<template>
	<div class="name">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<span>更换昵称</span>
			<div></div>
		</div>
		<div class="main">
			<van-field v-model="value" clearable placeholder="请输入用户名" />
			<div class="submit">
				<span>4-20个字符，可有中英文、数字特殊符号组成</span>
				<button @click="submit">保存</button>
			</div>
		</div>
	</div>

</template>

<script>


	export default {
		data() {
			return {
				value: ''
			}
		},

		created() {
			this.value = this.$route.query.name
		},
		methods: {
			submit() {
				if (this.value == '') {
					this.$toast('昵称不能为空')
				} else {
					this.$axios.post(baseUrl + '/mobile/User/userUpdateUsername', {
						username: this.value,
						id: this.$route.query.id
					}).then((res) => {
						if (res.data.code == 7) {
							this.$toast(res.data.msg);
							this.back();
						}
					}).catch((err) => {
						console.log(err);
					});
				}
			}
		}
	}
</script>

<style scoped>
	.name {
		height: 100%;
		background: #fff;
		padding-top: 2rem;
	}

	.name .main .van-field {
		margin-top: 1rem;
		padding-bottom: 0;
	}

	.van-cell:not(:last-child)::after {
		border-bottom: 0px;
	}

	.name .submit {
		margin: 0 1rem;
		border-top: 1px solid #F1452F;
		padding-top: 1rem;
		display: flex;
		flex-direction: column;
	}

	.name .submit span {
		font-size: 0.75rem;
		text-align: left;
		color: #bebebe;
	}

	.name .submit button {
		border-radius: 1rem;
		width: 8rem;
		height: 1.8rem;
		background: #F1452F;
		color: #fff;
		border: 0;
		font-size: 0.8rem;
		position: relative;
		margin: auto;
		top: 1.5rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/min/setting/name.vue